module.exports = __webpack_public_path__ + "img/Group 2232@2x.ba5c4501.png";